export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
	  {
      label: '主题',
      prop: 'subject',
      width: 120,
      solt: true,
    },
    {
      label: '描述',
      prop: 'description',
      width: 120,
      solt: true,
      hide: true
    },
    {
      label: '投票详情链接',
      prop: 'qrUrl',
      width: 150,
      solt: true,
    },
    {
      label: '类型',
      prop: 'type',
    },
    {
      label: '收集方式',
      prop: 'collectType',
      width: 150,
    },
    {
      label: '状态',
      prop: 'statusEnum',
      width: 110,
    },
    {
      label: '参与人数',
      prop: 'participantCount',
    },
    {
      label: '开始时间',
      prop: 'startTime',
      width: 180,
    },
    {
      label: '结束时间',
      prop: 'endTime',
      width: 180,
    },
    {
      label: '创建人',
      prop: 'creatorNickname',
    },
    {
      label: '创建时间',
      prop: 'insertedTime',
      width: 180,
    },
  ]
}

export const statusOptions = [
  { label: '未发布', value: 'NOT_PUBLISHED' },
  { label: '未开始', value: 'NOT_STARTED' },
  { label: '进行中', value: 'PROGRESSING' },
  { label: '已结束', value: 'ENDED' },
]

export const typeOptions = [
  { label: '文本', value: 'TEXT_VOTE' },
  { label: '图文', value: 'GRAPHIC_VOTE' }
]

export const collectTypeOptions = [
  { label: '只能投票一次', value: 'ONCE' },
  { label: '每天可投一次', value: 'ONCE_A_DAY' }
]

export const filterTypes = [
  // { label: '等于', value: 'equal' },
  // { label: '不等于', value: 'not-equal' },
  { label: '包含', value: 'include' },
  { label: '不包含', value: 'not-include' }
]